export default __webpack_public_path__ + "images/yup_5afbfd.svg";